// extracted by mini-css-extract-plugin
export default {"productFeatured":"Eaa-z","carousel":"Faa-z","slides":"Gaa-z","slide":"Haa-z","slideFeatured":"Iaa-z","zoomMode":"Jaa-z","fadeIn":"Kaa-z","imageSizing":"Laa-z"};